import type {
	ProcessedArticleBlock,
	ShowArticleProps,
} from './ShowArticleProps.d';

import React from 'react';
import './show-article.scss';
import { TextBlock } from './TextBlock';
import { ImageBlock } from './ImageBlock';
import { LinkBlock } from './LinkBlock';
import { FactBlock } from './FactBlock';


const ArticleBlocks = ({
	articleBlocks,
}: {
	articleBlocks: ProcessedArticleBlock[]
}): React.JSX.Element => (
	<>
		{articleBlocks?.map((block: ProcessedArticleBlock, index: number) => {
			if (!articleBlocks) return null;

			if (block.text) {
				return <TextBlock key={index} title={block.text.title} body={block.text.body} />;
			}
			if (block.image) {
				return <ImageBlock key={index} imageText={block.image.imageText} image={block.image.image} />;
			}
			if (block.linkBox) {
				return <LinkBlock key={index} title={block.linkBox.title} subtitle={block.linkBox.subtitle} links={block.linkBox.links} />;
			}
			if (block.factBox) {
				return <FactBlock key={index} factCards={block.factBox.factCards} />;
			}
			return null;
		})}
	</>
);


export function ShowArticle(props: ShowArticleProps): React.JSX.Element {
	const {
		articleBlocks,
	} = props.article;

	return (
		<article className="pt-lg tablet:pt-xl pb-xl tablet:pb-xxl">
			{articleBlocks && (
				<ArticleBlocks articleBlocks={articleBlocks}/>
			)}
		</article>
	);
}
